
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { usePhoneOrderDialog } from '@/contexts/PhoneOrderDialogContext';
import PhoneOrderForm from './PhoneOrderForm';

const PhoneOrderDialog: React.FC = () => {
  const { isOpen, closePhoneOrderDialog, handleSuccess } = usePhoneOrderDialog();

  return (
    <Dialog open={isOpen} onOpenChange={closePhoneOrderDialog}>
      <DialogContent className="max-w-4xl">
        <DialogHeader>
          <DialogTitle>Place Phone Order</DialogTitle>
          <DialogDescription>
            Enter customer details and payment information to complete a phone order for the Master Reseller Pro plan.
          </DialogDescription>
        </DialogHeader>
        <PhoneOrderForm onSuccess={handleSuccess} onCancel={closePhoneOrderDialog} />
      </DialogContent>
    </Dialog>
  );
};

export default PhoneOrderDialog;
